export enum AnswerCardStatus {
    New,
    Started,
    Done,
    Corrected
}
